// extracted by mini-css-extract-plugin
export default {"root":"bpLuccH4XE8QYDkF59EW","placeHolderShimmer":"KG2AQoaqDPFzLh87gNRE"};